import { render, staticRenderFns } from "./luckycard.vue?vue&type=template&id=1a2402ac&"
import script from "./luckycard.vue?vue&type=script&lang=js&"
export * from "./luckycard.vue?vue&type=script&lang=js&"
import style0 from "./luckycard.vue?vue&type=style&index=0&id=1a2402ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports